import { CustomerMock } from 'app/back-office/account.model';

export class SiteItem {
  constructor(
    public readonly id: number,
    public readonly name?: string,
    public readonly includeGroup?: string,
    public group?: string,
  ) {}
}
export type AccountsForUserFilter = CustomerMock | SiteItem;
